import React from 'react';
import Title from 'ui/Typography/Title';
import BackButton from '../BackButton/BackButton';
import RtlStyles from 'i18n/rtl';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { ProductGroup } from 'rangeConfig/@types';
import { useIntl } from 'react-intl';
import { MenuTitle } from './menuComponents';
import { usePlannerConfig } from 'contexts/plannerConfig';

type Props = {
  selectedGroup?: ProductGroup;
  showGroupNavBar: () => void;
};

const ProductMenuTitle = React.forwardRef(({ showGroupNavBar, selectedGroup }: Props, ref: any) => {
  const { formatMessage } = useIntl();

  const {
    plannerConfig: { productGroups }
  } = usePlannerConfig();

  const hideHeader = productGroups.length === 1; // Should not have back button if only one group

  const title = selectedGroup?.mainMenu.menuTitle;

  return (
    <MenuTitle ref={ref} pb="xs">
      <>
        {!hideHeader && (
          <RtlStyles>
            <BackButton
              mr="xs"
              onClick={showGroupNavBar}
              dataTestId="back-to-navigation-menu-back-button"
              aria-label={formatMessage({ id: 'storageone.back' })}
            />
          </RtlStyles>
        )}
      </>

      <RtlStyles>
        <Title
          type={ThemeFontStyleTypeEnum.headingMedium}
          pb={hideHeader ? 'l' : 'xxs'}
          px={hideHeader ? '1rem' : 0}
        >
          {formatMessage({ id: title })}
        </Title>
      </RtlStyles>
    </MenuTitle>
  );
});

export default ProductMenuTitle;
